module.exports = __webpack_public_path__ + "logo.png?63e2e33ed47f44aa94f2260296a814c9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 3
// module chunks = 1 2 3 4 5 6 7 8